<div class="container">
  <form>
    @if (authenticate.twoFactor) {
      <div>
        <div class="row">
          <mat-form-field appearance="outline" class="col-12">
            <mat-label>{{'authentication.lblTwoFactor' | translate}}</mat-label>
            <input name="code" type="text" placeholder="{{'authentication.lblTwoFactor' | translate}}" matInput required [(ngModel)]="authenticate.userCode">
            <span matSuffix class="clickable" style="color:  #122161;" (click)="resendTwoFactor()">{{'authentication.lblResend' | translate}}</span>
            <mat-error>{{'errRequired' | translate}}</mat-error>
          </mat-form-field>
          @if (canEnableHelp) {
            <div style="margin: 0px 20px 0px auto;">
              <span style="font-size: smaller; color: gray;">{{'authentication.lblNotReceived' | translate}}</span>
            </div>
          }
        </div>
      </div>
    }
    @if (authenticate.challengeQuestion) {
      <div>
        <div class="row">
          <mat-label>{{authenticate.question}}</mat-label>
          <mat-form-field appearance="outline" class="col-12">
            <mat-label>{{'authentication.lblAnswer' | translate}}</mat-label>
            <input name="answer" type="text" placeholder="{{'authentication.lblAnswer' | translate}}" matInput required [(ngModel)]="authenticate.userAnswer">
            <mat-error>{{'errRequired' | translate}}</mat-error>
          </mat-form-field>
        </div>
      </div>
    }
    <div class="row">
      <button mat-raised-button color="primary" type="button" (click)="OnSubmitClick()">{{'btnSubmit' | translate}}</button>
    </div>
  </form>
</div>